import React from 'react';
import MiniLeaderboard from './MiniLeaderboard';

interface ConditionalLeaderboardProps {
  /** Whether the host is playing (if true, show leaderboard; if false, hide it) */
  hostIsPlaying: boolean;
  /** Array of players */
  players: Array<{
    id: string;
    name: string;
    score: number;
    avatar?: string;
  }>;
  /** Current player's ID */
  myPlayerId: string;
  /** Optional set of player IDs who have answered (for highlighting) */
  answeredPlayerIds?: Set<string>;
}

/**
 * Conditionally displays leaderboard based on whether host is playing.
 * - If host is NOT playing: Leaderboard is hidden (only shown on host screen)
 * - If host IS playing: Leaderboard is shown on all screens
 */
export const ConditionalLeaderboard: React.FC<ConditionalLeaderboardProps> = ({
  hostIsPlaying,
  players,
  myPlayerId,
  answeredPlayerIds,
}) => {
  // If host is not playing, don't show leaderboard on player screens
  if (!hostIsPlaying) {
    return null;
  }

  // Host is playing - show leaderboard
  return (
    <MiniLeaderboard 
      players={players} 
      myPlayerId={myPlayerId}
      answeredPlayerIds={answeredPlayerIds}
    />
  );
};
